import {comboTasks} from './combos';

const reducers = {comboTasks};

export default reducers;
